import { GET_PAYMENT_DETAILS } from "../../Utils/types";

const initialState = {
  getPaymentDetails: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_PAYMENT_DETAILS:
      return {
        ...state,
        getPaymentDetails: action.payload,
      };
    default:
      return state;
  }
};
